import { getPage } from "./getPage";

export const getRout = () => {
  const $loader = $('.popup-loading-wrapper');
  $loader.show();

  $(document).on('click', '.get_page', function (e) {
    const $target = $(e.currentTarget);
    const page = $target.data('page');

    window.location.href = getPage(page);
  });
}
